import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";

import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInputNumber from "../common/form/labelAndInputNumber";
import Select from "../common/form/select";
import { setModoTela, initForm, setFiltro, getLista, alterarContratoMercadoLivreAno } from "./contratoMercadoLivreActions";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { adicionarBloqueioUsuarioImplantacao } from "../utils/adicionarBloqueioUsuarioImplantacao";
import { getUcValidarUsuarioImplantacao } from "../cliente/clienteActions";
import FileChooser from "../common/form/fileChooser/fileChooser";
import ButtonTable from "../common/table/buttonTable";
import FormatUtils from "../common/formatUtils/FormatUtils";

import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";

class ContratoMercadoLivreForm extends Component {
    state = {
        anoInicial: this.props.formularioValues.anos[0] ? this.props.formularioValues.anos[0].ano : null,
        anoFinal: this.props.formularioValues.anos[this.props.formularioValues.anos.length - 1]
            ? this.props.formularioValues.anos[this.props.formularioValues.anos.length - 1].ano
            : null,
        itemSelecionado: {},
    };

    componentWillMount() {
        this.props.getUcValidarUsuarioImplantacao();
        this.props.setFiltro({
            ...this.props.filtro,
            id_cliente: null,
            id_unidade_consumidora: null,
        });
        this.props.getLista();
    }

    render() {
        const readOnly = !!(this.props.excluir || this.props.visualizacao);

        const listaUCsFiltradasImplantacao = this.props.listaUnidadeConsumidora.filter(
            (uc) => !this.props.usuarioLogado.usuario_implantacao || uc.id_usuario_implantacao == this.props.usuarioLogado.id
        );

        const listaClienteFiltrada = this.props.listaCliente.filter((item) => listaUCsFiltradasImplantacao.find((uc) => uc.id_cliente == item.id));
        const listaUCsAtivas = listaUCsFiltradasImplantacao.filter((uc) => {
            const clienteValidado = !this.props.formularioValues.id_cliente || uc.id_cliente == this.props.formularioValues.id_cliente;
            return clienteValidado && uc.id_tipo_mercado == 2;
        });

        return (
            <ContentCard>
                <Form event={this.props.handleSubmit}>
                    <ContentCardBody>
                        <Row>
                            <Field
                                name="id_cliente"
                                component={Select}
                                options={listaClienteFiltrada}
                                label="Cliente"
                                cols="12 12 12 12"
                                placeholder="Selecione o cliente"
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <Field
                                name="id_unidade_consumidora"
                                component={Select}
                                options={listaUCsAtivas}
                                label="Unidade Consumidora"
                                cols="12 12 12 12"
                                placeholder="Selecione a unidade consumidora"
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <LabelAndInputNumber
                                name="anoInicial"
                                label="Ano Inicial"
                                placeholder={"Ex: " + new Date().getFullYear()}
                                readOnly={readOnly || this.props.formularioValues.id}
                                cols="12 12 2 2"
                                casas={0}
                                value={this.state.anoInicial}
                                allowNegative={false}
                                onChange={(data) => {
                                    this.setState({
                                        ...this.state,
                                        anoInicial: data.target.value,
                                    });
                                }}
                            />
                            <LabelAndInputNumber
                                name="anoFinal"
                                label="Ano Final"
                                placeholder={"Ex: " + (new Date().getFullYear() + 5)}
                                readOnly={readOnly || !this.state.anoInicial || this.props.formularioValues.id}
                                cols="12 12 2 2"
                                casas={0}
                                value={this.state.anoFinal}
                                allowNegative={false}
                                onChange={(data) => {
                                    const anoFinal = parseInt(data.target.value);

                                    if (anoFinal >= this.state.anoInicial) {
                                        const tamanhoLista = anoFinal - this.state.anoInicial + 1;
                                        if (tamanhoLista > 10) return window.alert("A lista não pode ter mais de 10 anos");

                                        const anos = Array.from({ length: tamanhoLista }, (_, i) => {
                                            const ano = parseInt(this.state.anoInicial) + i;
                                            return {
                                                ano,
                                                valor_contratado_anual: 0,
                                                quantidade_energia_contratada_mensal: 0,
                                                flexibilidade_minima: 0,
                                                flexibilidade_maxima: 0,
                                            };
                                        });

                                        this.props.initForm({
                                            ...this.props.formularioValues,
                                            anos,
                                        });
                                    }
                                    this.setState({
                                        ...this.state,
                                        anoFinal: data.target.value,
                                    });
                                }}
                            />
                        </Row>
                        <Row style={{ height: 20 }}>
                            <Grid cols="12 12 2 2"></Grid>
                            <Grid cols="12 12 2 2">
                                <small style={{ color: "#ff3358" }}>{this.state.anoFinal >= this.state.anoInicial ? "" : "O ano final deve ser maior ou igual ao inicial"}</small>
                            </Grid>
                        </Row>
                        {this.state.anoInicial && this.state.anoFinal
                            ? this.props.formularioValues.anos.map((item, i) => {
                                  return (
                                      <Row
                                          key={item.ano}
                                          style={{ marginBottom: window.innerWidth < 768 ? 40 : 2, marginInline: 5, paddingTop: 20, boxShadow: "0px 0px 3px 1px #CCC" }}
                                      >
                                          <Grid cols="12 12 1 1">
                                              <div
                                                  style={{
                                                      width: "100%",
                                                      backgroundColor: "#1477ff",
                                                      color: "#FFF",
                                                      display: "flex",
                                                      height: window.innerWidth < 768 ? 40 : 70,
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                  }}
                                              >
                                                  <h5 style={{ marginBottom: 0 }}>{item.ano}</h5>
                                              </div>
                                          </Grid>
                                          <LabelAndInputNumber
                                              name="valor_contratado_anual"
                                              label="Valor Contratado por Ano (R$/MWh)"
                                              placeholder="0,00"
                                              readOnly={readOnly || (item.id && this.state.itemSelecionado.ano != item.ano)}
                                              cols="12 12 2 2"
                                              casas={2}
                                              value={item.valor_contratado_anual}
                                              allowNegative={false}
                                              onChange={(data) => {
                                                  const listaAtualizada = this.props.formularioValues.anos.map((ano, indice) => ({
                                                      ...ano,
                                                      valor_contratado_anual: i == indice ? data.target.value : ano.valor_contratado_anual,
                                                  }));

                                                  this.props.initForm({
                                                      ...this.props.formularioValues,
                                                      anos: listaAtualizada,
                                                  });
                                              }}
                                          />
                                          <LabelAndInputNumber
                                              name="quantidade_energia_contratada_mensal"
                                              label="Qtd. de Energia Contratada por Mês (kWh)"
                                              placeholder="0,00"
                                              readOnly={readOnly || (item.id && this.state.itemSelecionado.ano != item.ano)}
                                              cols="12 12 2 2"
                                              casas={2}
                                              value={item.quantidade_energia_contratada_mensal}
                                              allowNegative={false}
                                              onChange={(data) => {
                                                  const listaAtualizada = this.props.formularioValues.anos.map((ano, indice) => ({
                                                      ...ano,
                                                      quantidade_energia_contratada_mensal: i == indice ? data.target.value : ano.quantidade_energia_contratada_mensal,
                                                  }));

                                                  this.props.initForm({
                                                      ...this.props.formularioValues,
                                                      anos: listaAtualizada,
                                                  });
                                              }}
                                          />

                                          <LabelAndInputNumber
                                              name="flexibilidade_minima"
                                              label="Flexibilidade Mínima (%)"
                                              placeholder="0,00"
                                              readOnly={readOnly || (item.id && this.state.itemSelecionado.ano != item.ano)}
                                              cols="12 12 2 2"
                                              casas={2}
                                              value={item.flexibilidade_minima}
                                              allowNegative={false}
                                              onChange={(data) => {
                                                  const listaAtualizada = this.props.formularioValues.anos.map((ano, indice) => ({
                                                      ...ano,
                                                      flexibilidade_minima: i == indice ? data.target.value : ano.flexibilidade_minima,
                                                  }));

                                                  this.props.initForm({
                                                      ...this.props.formularioValues,
                                                      anos: listaAtualizada,
                                                  });
                                              }}
                                          />
                                          <Grid cols="12 12 1 1">
                                              <div
                                                  style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      height: "100%",
                                                      fontWeight: "bold",
                                                      color: "#2988ff",
                                                      paddingTop: window.innerWidth < 768 ? 0 : 15,
                                                      paddingBottom: window.innerWidth < 768 ? 15 : 0,
                                                  }}
                                              >
                                                  {`${adicionarPontosMilhar(
                                                      parseFloat(FormatUtils.formatarValorBanco(item.quantidade_energia_contratada_mensal, 2)) -
                                                          (parseFloat(FormatUtils.formatarValorBanco(item.quantidade_energia_contratada_mensal)) *
                                                              parseFloat(FormatUtils.formatarValorBanco(item.flexibilidade_minima))) /
                                                              100
                                                  )} kWh`}
                                              </div>
                                          </Grid>
                                          <LabelAndInputNumber
                                              name="flexibilidade_maxima"
                                              label="Flexibilidade Máxima (%)"
                                              placeholder="0,00"
                                              readOnly={readOnly || (item.id && this.state.itemSelecionado.ano != item.ano)}
                                              cols="12 12 2 2"
                                              casas={2}
                                              value={item.flexibilidade_maxima}
                                              allowNegative={false}
                                              onChange={(data) => {
                                                  const listaAtualizada = this.props.formularioValues.anos.map((ano, indice) => ({
                                                      ...ano,
                                                      flexibilidade_maxima: i == indice ? data.target.value : ano.flexibilidade_maxima,
                                                  }));

                                                  this.props.initForm({
                                                      ...this.props.formularioValues,
                                                      anos: listaAtualizada,
                                                  });
                                              }}
                                          />
                                          <Grid cols="12 12 1 1">
                                              <div
                                                  style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      height: "100%",
                                                      fontWeight: "bold",
                                                      color: "#d90424",
                                                      paddingTop: window.innerWidth < 768 ? 0 : 15,
                                                      paddingBottom: window.innerWidth < 768 ? 15 : 0,
                                                  }}
                                              >
                                                  {`${adicionarPontosMilhar(
                                                      parseFloat(FormatUtils.formatarValorBanco(item.quantidade_energia_contratada_mensal, 2)) +
                                                          (parseFloat(FormatUtils.formatarValorBanco(item.quantidade_energia_contratada_mensal)) *
                                                              parseFloat(FormatUtils.formatarValorBanco(item.flexibilidade_maxima))) /
                                                              100
                                                  )} kWh`}
                                              </div>
                                          </Grid>
                                          <Grid cols="12 12 1 1">
                                              <div
                                                  style={{
                                                      display: "flex",
                                                      height: "100%",
                                                      justifyContent: window.innerWidth < 768 ? "flex-start" : "flex-end",
                                                      alignItems: "center",
                                                      paddingTop: 15,
                                                      paddingRight: 30,
                                                  }}
                                              >
                                                  {this.state.itemSelecionado.ano == item.ano ? (
                                                      <>
                                                          <ButtonTable
                                                              visible={true}
                                                              disabled={readOnly}
                                                              type={"success"}
                                                              icon={"fa fa-check"}
                                                              event={() => {
                                                                  const callback = () => this.setState({ ...this.state, itemSelecionado: {} });
                                                                  this.props.alterarContratoMercadoLivreAno(item, callback);
                                                              }}
                                                          />
                                                          <ButtonTable
                                                              visible={true}
                                                              disabled={readOnly}
                                                              type={"danger"}
                                                              icon={"fa fa-times"}
                                                              event={() => {
                                                                  const listaAtualizada = this.props.formularioValues.anos.map((ano) =>
                                                                      ano.ano == this.state.itemSelecionado.ano ? { ...this.state.itemSelecionado } : ano
                                                                  );

                                                                  this.props.initForm({
                                                                      ...this.props.formularioValues,
                                                                      anos: listaAtualizada,
                                                                  });
                                                                  this.setState({
                                                                      ...this.state,
                                                                      itemSelecionado: {},
                                                                  });
                                                              }}
                                                          />
                                                      </>
                                                  ) : (
                                                      <ButtonTable
                                                          visible={true}
                                                          type={"warning"}
                                                          icon={"fa fa-pencil-alt"}
                                                          disabled={readOnly}
                                                          event={() => {
                                                              this.setState({
                                                                  ...this.state,
                                                                  itemSelecionado: { ...item },
                                                              });
                                                          }}
                                                      />
                                                  )}
                                              </div>
                                          </Grid>
                                      </Row>
                                  );
                              })
                            : null}
                        <Row>
                            <Grid cols="12 12 12 12" style={{ paddingLeft: 4, paddingRight: 6 }}>
                                {this.props.formularioValues.arquivo_contrato ? (
                                    <div
                                        className="d-flex"
                                        style={{
                                            margin: 15,
                                            gap: 10,
                                            padding: 10,
                                            backgroundColor: "#f4f4f4",
                                        }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{ color: "#0040ff", border: "1px solid #0040ff", height: 40, width: 40, fontSize: "1.4rem" }}
                                        >
                                            <i className="fas fa-file" />
                                        </div>
                                        <Button
                                            disabled={readOnly}
                                            style={{ margin: 0 }}
                                            text={"Remover Arquivo"}
                                            type={"danger"}
                                            icon={"fa fa-times"}
                                            event={() => {
                                                this.props.initForm({
                                                    ...this.props.formularioValues,
                                                    arquivo_contrato: null,
                                                });
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <FileChooser
                                        solid={true}
                                        style={{ margin: "0px 5px" }}
                                        readOnly={readOnly}
                                        nome=""
                                        base64=""
                                        label="Arquivo do Contrato"
                                        onFileSelect={async (base64ComNomeJSON) => {
                                            this.props.initForm({
                                                ...this.props.formularioValues,
                                                arquivo_contrato: base64ComNomeJSON.base64,
                                            });
                                        }}
                                    />
                                )}
                            </Grid>
                        </Row>
                        <ContentCardBody>
                            <Row alignCenter style={{ marginBlock: 30 }}>
                                <Grid cols="6 6 4 3">
                                    {this.props.excluir ? (
                                        <Button text="Excluir" submit type={"danger"} icon={"fa fa-trash"} disabled={this.props.visualizacao} />
                                    ) : (
                                        <Button text={"Salvar"} submit type={"success"} icon={"fa fa-check"} disabled={this.props.visualizacao || this.state.itemSelecionado.ano} />
                                    )}
                                </Grid>
                                <Grid cols="6 6 4 3">
                                    <Button
                                        text="Voltar"
                                        type={"warning"}
                                        icon={"fa fa-chevron-left"}
                                        event={() => {
                                            this.props.getLista();
                                            this.props.setModoTela("lista");
                                        }}
                                    />
                                </Grid>
                            </Row>
                        </ContentCardBody>
                    </ContentCardBody>
                </Form>
            </ContentCard>
        );
    }
}

ContratoMercadoLivreForm = reduxForm({ form: "contratoMercadoLivreForm", destroyOnUnmount: false })(ContratoMercadoLivreForm);
const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    formularioValues: getFormValues("contratoMercadoLivreForm")(state),
    registro: state.contratoMercadoLivre.registro,
    listaCliente: state.contratoMercadoLivre.listaCliente,
    listaUnidadeConsumidora: state.contratoMercadoLivre.listaUnidadeConsumidora,
    lista: adicionarBloqueioUsuarioImplantacao(state.auth.usuarioLogado, state.cliente.listaUcValidarUsuarioImplantacao, state.contratoMercadoLivre.lista),
    listaMeses: state.contratoMercadoLivre.listaMeses,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            getLista,
            setArquivoPDF,
            getUcValidarUsuarioImplantacao,
            alterarContratoMercadoLivreAno,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(ContratoMercadoLivreForm);
